module.exports = __webpack_public_path__ + "static/media/INVR.c1ef34b6.png";